import { Alert, AlertIcon, Box, HStack, Spinner, Text } from "@chakra-ui/react";
import React from "react";
import { entityProfileModalColors } from "../entityProfileModal.theme";
import EntityModalButton from "./EntityModalButton";

type EntityProfileLoadingStateProps = {
  label: string;
};

export function EntityProfileLoadingState(props: EntityProfileLoadingStateProps) {
  return (
    <Box color={entityProfileModalColors.muted} py={6} textAlign="center">
      <Spinner mr={3} size="sm" />
      {props.label}
    </Box>
  );
}

type EntityProfileErrorStateProps = {
  label: string;
  onRetry?: () => void;
};

export function EntityProfileErrorState(props: EntityProfileErrorStateProps) {
  return (
    <Alert status="error">
      <AlertIcon />
      <Text flex={1}>{props.label}</Text>
      {props.onRetry ? (
        <EntityModalButton kind="white" size="sm" onClick={props.onRetry}>
          Retry
        </EntityModalButton>
      ) : null}
    </Alert>
  );
}

type EntityProfileEmptyStateProps = {
  children: React.ReactNode;
};

export function EntityProfileEmptyState(props: EntityProfileEmptyStateProps) {
  return <Text color={entityProfileModalColors.muted}>{props.children}</Text>;
}

type EntityProfileSaveStatusProps = {
  status: "idle" | "saving" | "saved";
  savedLabel: string;
  savingLabel: string;
};

export function EntityProfileSaveStatus(props: EntityProfileSaveStatusProps) {
  if (props.status === "saving") {
    return (
      <HStack color={entityProfileModalColors.secondaryText} fontSize="13px">
        <Spinner size="xs" />
        <Text>{props.savingLabel}</Text>
      </HStack>
    );
  }

  if (props.status === "saved") {
    return (
      <Text color={entityProfileModalColors.success} fontSize="13px">
        {props.savedLabel}
      </Text>
    );
  }

  return null;
}
